import React, { useMemo, useState } from 'react';
import { TICKET_CATEGORY, TICKET_PRIORITY } from '../constants/ticketConstants';

export default function SupportTicketForm({ onSubmit, submitting }) {
  const [subject, setSubject] = useState('');
  const [category, setCategory] = useState(TICKET_CATEGORY.OTHER);
  const [priority, setPriority] = useState(TICKET_PRIORITY.NORMAL);
  const [message, setMessage] = useState('');

  const canSubmit = useMemo(() => {
    return subject.trim().length >= 4 && message.trim().length >= 10 && !submitting;
  }, [subject, message, submitting]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    await onSubmit({ subject: subject.trim(), category, priority, message: message.trim() });
    setSubject('');
    setCategory(TICKET_CATEGORY.OTHER);
    setPriority(TICKET_PRIORITY.NORMAL);
    setMessage('');
  };

  return (
    <form className="st-form" onSubmit={handleSubmit}>
      <div className="st-field">
        <label htmlFor="st-subject">Subject</label>
        <input
          id="st-subject"
          className="st-input"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="e.g. I can’t see my upcoming appointment"
          maxLength={120}
          autoComplete="off"
        />
      </div>

      <div className="st-row2">
        <div className="st-field">
          <label htmlFor="st-category">Category</label>
          <select
            id="st-category"
            className="st-select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value={TICKET_CATEGORY.APPOINTMENTS}>Appointments</option>
            <option value={TICKET_CATEGORY.ACCOUNT}>Account</option>
            <option value={TICKET_CATEGORY.BILLING}>Billing</option>
            <option value={TICKET_CATEGORY.TECHNICAL}>Technical</option>
            <option value={TICKET_CATEGORY.FEATURE_REQUEST}>Feature request</option>
            <option value={TICKET_CATEGORY.OTHER}>Other</option>
          </select>
        </div>

        <div className="st-field">
          <label htmlFor="st-priority">Priority</label>
          <select
            id="st-priority"
            className="st-select"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          >
            <option value={TICKET_PRIORITY.LOW}>Low</option>
            <option value={TICKET_PRIORITY.NORMAL}>Normal</option>
            <option value={TICKET_PRIORITY.HIGH}>High</option>
            <option value={TICKET_PRIORITY.URGENT}>Urgent</option>
          </select>
        </div>
      </div>

      <div className="st-field">
        <label htmlFor="st-message">Message</label>
        <textarea
          id="st-message"
          className="st-textarea"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Include any helpful details (what you tried, error messages, device, etc.)"
          maxLength={4000}
        />
      </div>

      <div className="st-actions">
        <button className="st-btn st-btnPrimary" type="submit" disabled={!canSubmit}>
          {submitting ? 'Submitting…' : 'Submit ticket'}
        </button>
      </div>
    </form>
  );
}

